/* BreadcrumbComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./BreadcrumbRenderer");

class BreadcrumbComponent extends EventEmitter {
    constructor(logger) {
        super();
        this._logger = logger;
        this._breadcrumbs = [];
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    get logger() {
        return this._logger;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._logger = undefined;
            this._breadcrumbs = undefined;
            this._renderer = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    onLeftArrowClicked(breadcrumb) {
        this.emit("LeftArrowClicked", breadcrumb);
    }
    onRightArrowClicked(breadcrumb) {
        this.emit("RightArrowClicked", breadcrumb);
    }
    onContentClicked(breadcrumb) {
        this.emit("ContentClicked", breadcrumb);
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get breadcrumbs() {
        return this.getBreadcrumbs();
    }
    getBreadcrumbs() {
        return this._breadcrumbs;
    }
    set breadcrumbs(bcs) {
        this.setBreadcrumbs(bcs);
    }
    setBreadcrumbs(bcs, silent) {
        let old = this._breadcrumbs;
        this._breadcrumbs = bcs;
        if (!silent) {
            this.emit("BreadcrumbChanged", this._breadcrumbs, old);
        }
        return this;
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = BreadcrumbComponent;
